import React from "react";
import { Form, Input, Row, Col, Button, Select, Spin } from "antd";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import Endpoints from "../../api/endpoints.js";
import EndpointFunctions from "../../utils/Functions/endpointFunctions.js";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import { useState, useEffect } from "react";

const ApplicationForm = ({ form, onFinish, initialValues }) => {
  const [appOptions, setAppOptions] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    fetchAppOptions();
  }, []);

  useEffect(() => {
    if (initialValues != null) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues]);

  const fetchAppOptions = async () => {
    setIsLoading(true);
    const result = await EndpointFunctions.fetchData({
      endpointURL: Endpoints.getAllApps,
      axiosPrivate: axiosPrivate,
    });
    if (result.success) {
      const appOption = result.data.map((item) => {
        return { value: item.name, label: item.description };
      });
      setAppOptions(appOption);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Spin spinning={isLoading}>
              <Form.Item name="app" label="Uygulama:">
                <Select options={appOptions} placeholder="Uygulama" />
              </Form.Item>
            </Spin>
          </Col>
        </Row>

        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Form.Item name="iosLink" label="iOS Bağlantısı:">
              <Input placeholder="iOS Bağlantısı" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[10, 10]}>
          <Col style={{ flex: 1 }}>
            <Form.Item name="androidLink" label="Android Bağlantısı:">
              <Input placeholder="Android Bağlantısı" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginTop: 8, width: "25%" }}>
            Gönder
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ApplicationForm;
